export const environment = {
  production: true,
  apiUrl: 'https://yv-api-stage.production.am/api/v1',
};
